import * as React from 'react';
import { observer } from 'mobx-react';
import { motion } from 'framer-motion';

import Content from '../../Content';

import { useAnimation } from './hooks';

type Props = {
  footer?: React.ReactNode;
};

const ChannelsList: React.FC<Props> = ({ footer }: Props) => {
  const { showSelectedChannel, ref } = useAnimation();

  return (
    <motion.div ref={ref}>
      {!showSelectedChannel && <Content footer={footer} />}
    </motion.div>
  );
};

export default observer(ChannelsList);
